'use strict';
var foreach = require('../utils/foreach'),
    _eventSplitter = /^([a-zA-Z0-9_-]+)\s+(.*)/;

/**
 * Load the events passed by @param events with a Backbone-like events definition
 *
 * @param {object} observable
 * @param {object} events
 */
function eventsAPI(observable, events) {
    events = events || {};

    foreach(events, function (cb, event) {
        var method;

        if (typeof cb === 'string') {
            method = cb;
            cb = observable[method];
        }

        /**
         *
         * @param {object} evt
         */
        function eventCb(evt) {
            /*jshint validthis:true */
            cb.call(this, evt, observable);
        }

        if (_eventSplitter.test(event)) {
            event = event.split(_eventSplitter);

            observable.on(event[1], event[2], eventCb);
        } else {
            observable.on(event, eventCb);
        }
    });
}

module.exports = eventsAPI;
